import { customElement, property } from 'lit/decorators.js'
import { LitElement, html, css } from 'lit'

@customElement('zaptic-report-status')
export class ReportStatus extends LitElement {
    @property({ attribute: 'status-name' })
    statusName = ''

    static styles = css`
        :host {
            display: flex;
        }

        .container {
            align-items: center;
            background-color: var(--darkerCloudGrey);
            border-radius: var(--ReportStatus-border-radius);
            padding: var(--ReportStatus-padding);
        }

        .container span {
            color: var(--darkGrey);
            font-style: var(--ReportStatus-font-style);
            font-size: var(--ReportStatus-font-size);
            font-weight: var(--ReportStatus-font-weight, var(--font-weight-bold));
            letter-spacing: var(--ReportStatus-letter-spacing);
            line-height: var(--ReportStatus-line-height);
        }
    `

    render() {
        return html` <div class="container"><span>${this.statusName.toUpperCase()}</span></div> `
    }
}
